// extracted by mini-css-extract-plugin
export default {"main":"GithubStats_main__xhfLM","h1":"GithubStats_h1__vs5d4"};